import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-table-info-row',
    template: ''
})
export class TableInfoRowComponent {
    @ContentChild('body', {static: false}) bodyTmpl: TemplateRef<any>;

    @Input() record;
}
